import React, { useState } from 'react';
import Modal from '../index';
import Button from '../../Button';
import { formatTelephone } from '../../../services/utils/formatTELandCEP';
import {
  RadioButtonWhatsAppOption,
  RadioButtonSMSOption,
  WhatsAppChecked,
  SMSChecked,
  DescriptionSection,
  Description,
  Links,
  Options,
  WhatsAppIcon,
  ChatBubbleLineIcon,
  FooterSection,
  OptionText,
  ButtonSection,
} from './styles';
import { useSelector } from 'react-redux';

interface Props {
  handlerClose: () => void;
  optionToValidade: Function;
  setAutoFocus: Function;
  telephone: string;
}

type TypeOptions = {
  whatsApp: boolean;
  sms: boolean;
};

const OptionValidateModal: React.FC<Props> = (props: Props) => {
  const [optionClicked, setOptionClicked] = useState<TypeOptions>({
    whatsApp: false,
    sms: false,
  });

  const { useWhatsappToken, useSMSToken } = useSelector(
    (state: ApplicationState) => ({
      useWhatsappToken: state.config.enviaTokenWhatsapp === 'true',
      useSMSToken: state.config.enviaTokenSMS === 'true',
    })
  );

  const useSomeToken = useWhatsappToken || useSMSToken;

  const onClickOption = (option: string) => {
    option === 'whatsapp'
      ? setOptionClicked({ whatsApp: true, sms: false })
      : setOptionClicked({ whatsApp: false, sms: true });
  };

  const changeTelephone = () => {
    props.handlerClose();
    props.setAutoFocus('FOCUS_INPUT_PHONE');
  };
  return (
    <Modal
      title={'Validar celular'}
      width={'464px'}
      handlerClose={props.handlerClose}
    >
      <DescriptionSection>
        <Description phone={true}>
          {`+55${' '}
        ${formatTelephone(props.telephone)}`}
        </Description>
        <Description phone={false}>
          {useSomeToken
            ? 'Escolha abaixo como deseja receber o Token:'
            : 'Não possui opções para receber Token.'}
        </Description>
      </DescriptionSection>

      {useWhatsappToken && (
        <Options onClick={() => onClickOption('whatsapp')}>
          <WhatsAppIcon />
          <OptionText>Receber código por WhatsApp</OptionText>
          <RadioButtonWhatsAppOption whatsApp={optionClicked.whatsApp} />
          <WhatsAppChecked whatsApp={optionClicked.whatsApp} />
        </Options>
      )}
      {useSMSToken && (
        <Options onClick={() => onClickOption('sms')}>
          <ChatBubbleLineIcon />
          <OptionText>Receber código por SMS</OptionText>
          <RadioButtonSMSOption
            onClick={() => onClickOption('sms')}
            sms={optionClicked.sms}
          />
          <SMSChecked sms={optionClicked.sms} />
        </Options>
      )}

      <ButtonSection>
        <Button
          height={60}
          color={'primary'}
          block={true}
          transform={true}
          fontSize='16'
          borderRadios='16'
          onClick={() => props.optionToValidade(optionClicked)}
          style={{ marginTop: '12px' }}
          disabled={!useSomeToken}
        >
          ENVIAR TOKEN
        </Button>
      </ButtonSection>

      <FooterSection>
        <Links onClick={props.handlerClose}>Cancelar</Links>
        <Links onClick={() => changeTelephone()}>
          Alterar número de telefone
        </Links>
      </FooterSection>
    </Modal>
  );
};

export default OptionValidateModal;
